var _dec, _dec2, _class, _descriptor, _descriptor2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _dec9, _dec0, _dec1, _class3, _descriptor9, _descriptor0, _descriptor1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _class4, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _dec17, _dec18, _class5, _descriptor17, _descriptor18;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import BoxDrawingTraits from "../BoxDrawingTraits";
import objectArrayTrait from "../Decorators/objectArrayTrait";
import objectTrait from "../Decorators/objectTrait";
import primitiveArrayTrait from "../Decorators/primitiveArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import ModelTraits from "../ModelTraits";
import LatLonHeightTraits from "./LatLonHeightTraits";
export let ClippingPlaneDefinitionTraits = (_dec = primitiveTrait({
  name: "Distance",
  type: "number",
  description: " The shortest distance from the origin to the plane. The sign of distance determines which side of the plane the origin is on. If distance is positive, the origin is in the half-space in the direction of the normal; if negative, the origin is in the half-space opposite to the normal; if zero, the plane passes through the origin."
}), _dec2 = primitiveArrayTrait({
  name: "Normal Cartesian3",
  type: "number",
  description: "The plane's normal (normalized)."
}), _class = class ClippingPlaneDefinitionTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "distance", _descriptor, this);
    _initializerDefineProperty(this, "normal", _descriptor2, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "distance", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "normal", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _class);
export let ClippingPlaneCollectionTraits = (_dec3 = primitiveTrait({
  type: "boolean",
  name: "Enabled Clipping Plane",
  description: "Determines whether the clipping planes are active."
}), _dec4 = primitiveTrait({
  type: "boolean",
  name: "UnionClippingRegions",
  description: "If true, a region will be clipped if it is on the outside of any plane in the collection. Otherwise, a region will only be clipped if it is on the outside of every plane."
}), _dec5 = primitiveTrait({
  type: "number",
  name: "Edge Width",
  description: "The width, in pixels, of the highlight applied to the edge along which an object is clipped."
}), _dec6 = primitiveTrait({
  type: "string",
  name: "Edge Color",
  description: "The color applied to highlight the edge along which an object is clipped."
}), _dec7 = objectArrayTrait({
  type: ClippingPlaneDefinitionTraits,
  name: "Clipping Plane Array",
  description: "An array of ClippingPlane objects used to selectively disable rendering on the outside of each plane.",
  idProperty: "index"
}), _dec8 = primitiveArrayTrait({
  name: "Model Matrix",
  type: "number",
  description: "The 4x4 transformation matrix specifying an additional transform relative to the clipping planes original coordinate system."
}), _class2 = class ClippingPlaneCollectionTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "enabled", _descriptor3, this);
    _initializerDefineProperty(this, "unionClippingRegions", _descriptor4, this);
    _initializerDefineProperty(this, "edgeWidth", _descriptor5, this);
    _initializerDefineProperty(this, "edgeColor", _descriptor6, this);
    _initializerDefineProperty(this, "planes", _descriptor7, this);
    _initializerDefineProperty(this, "modelMatrix", _descriptor8, this);
  }
}, _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "enabled", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "unionClippingRegions", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "edgeWidth", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "edgeColor", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "planes", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "modelMatrix", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
export let ClippingBoxDimensionTraits = (_dec9 = primitiveTrait({
  type: "number",
  name: "Length",
  description: "Length of the clipping box (along the x-axis)."
}), _dec0 = primitiveTrait({
  type: "number",
  name: "Length",
  description: "Width of the clipping box (along the y-axis)."
}), _dec1 = primitiveTrait({
  type: "number",
  name: "Length",
  description: "Height of the clipping box."
}), _class3 = class ClippingBoxDimensionTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "length", _descriptor9, this);
    _initializerDefineProperty(this, "width", _descriptor0, this);
    _initializerDefineProperty(this, "height", _descriptor1, this);
  }
}, _descriptor9 = _applyDecoratedDescriptor(_class3.prototype, "length", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class3.prototype, "width", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class3.prototype, "height", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class3);
export let ClippingBoxTraits = (_dec10 = primitiveTrait({
  type: "boolean",
  name: "Enable clipping box features",
  description: "Set false to completely disable clipping box feature for the item."
}), _dec11 = primitiveTrait({
  type: "boolean",
  name: "Toggle model clipping.",
  description: "Applies clipping when true."
}), _dec12 = primitiveTrait({
  type: "boolean",
  name: "Show clipping box",
  description: "Shows a 3D box and associated UI for editing the clip volume."
}), _dec13 = primitiveTrait({
  type: "boolean",
  name: "Keep clipping box above ground",
  description: "When true, prevents the box from going underground."
}), _dec14 = objectTrait({
  type: LatLonHeightTraits,
  name: "position",
  description: "Latitude, longitude and height of the clipping box. When not set, the box is positioned at the center of the screen."
}), _dec15 = objectTrait({
  type: ClippingBoxDimensionTraits,
  name: "Dimensions",
  description: "The length, width and height of the clipping box. When not set, the box will be 1/3rd the screen size."
}), _dec16 = primitiveTrait({
  type: "string",
  name: "Clip direction",
  description: "Whether to clip the model outside of the box or inside. When this value is \"outside\", everything outside the box is clipped and when the value is \"inside\", everything inside the box is clipped. Default value is \"inside\""
}), _class4 = class ClippingBoxTraits extends mixTraits(BoxDrawingTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "enableFeature", _descriptor10, this);
    _initializerDefineProperty(this, "clipModel", _descriptor11, this);
    _initializerDefineProperty(this, "showClippingBox", _descriptor12, this);
    _initializerDefineProperty(this, "keepBoxAboveGround", _descriptor13, this);
    _initializerDefineProperty(this, "position", _descriptor14, this);
    _initializerDefineProperty(this, "dimensions", _descriptor15, this);
    _initializerDefineProperty(this, "clipDirection", _descriptor16, this);
  }
}, _descriptor10 = _applyDecoratedDescriptor(_class4.prototype, "enableFeature", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class4.prototype, "clipModel", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class4.prototype, "showClippingBox", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class4.prototype, "keepBoxAboveGround", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class4.prototype, "position", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class4.prototype, "dimensions", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class4.prototype, "clipDirection", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "inside";
  }
}), _class4);
let ClippingPlanesTraits = (_dec17 = objectTrait({
  type: ClippingPlaneCollectionTraits,
  name: "ClippingPlanes",
  description: "The ClippingPlaneCollection used to selectively disable rendering the tileset."
}), _dec18 = objectTrait({
  type: ClippingBoxTraits,
  name: "Clipping box",
  description: "Defines a user controllable clipping box used to hide or show sections of a model."
}), _class5 = class ClippingPlanesTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "clippingPlanes", _descriptor17, this);
    _initializerDefineProperty(this, "clippingBox", _descriptor18, this);
  }
}, _descriptor17 = _applyDecoratedDescriptor(_class5.prototype, "clippingPlanes", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class5.prototype, "clippingBox", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class5);
export { ClippingPlanesTraits as default };